import { Note } from '@/@types/note';
import { api } from '@/services/apiClient';
import { useQuery } from '@tanstack/react-query';

import { NoteApiResponse, transformNoteToFrontend } from '../utils/notes.utils';

type GetNoteProps = {
  id?: number;
};

export async function getNote({ id }: GetNoteProps): Promise<Note> {
  const { data } = await api.get<NoteApiResponse>(`/notes/${id}`);

  return transformNoteToFrontend(data);
}

export function useGetNote({ id }: GetNoteProps) {
  return useQuery({
    queryKey: ['note', id],
    queryFn: () => getNote({ id }),
    enabled: !!id,
    staleTime: 1000 * 60,
  });
}
